import PropTypes from 'prop-types';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Accordion from '@zenbusiness/zui/Accordion';
import AccordionDetails from '@zenbusiness/zui/AccordionDetails';
import AccordionSummary from '@zenbusiness/zui/AccordionSummary';
import Box from '@zenbusiness/zui/Box';
import Text from '@zenbusiness/zui/Text';

import { messageFormatValues as sharedMessageFormatValues } from '#client/pages/ProductLanding/utils/messageFormatValues';

import * as Styled from './FaqItem.style';

const messageFormatValues = {
  ...sharedMessageFormatValues,
  ul: (chunks) => <Styled.FaqList>{chunks}</Styled.FaqList>,
  li: (chunks) => <Box component="li">{chunks}</Box>,
};

function FaqItem({ item: { question, answer } }) {
  return (
    <Accordion gap={2}>
      <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ width: 24, height: 24 }} />}>
        <FormattedMessage id={question} />
      </AccordionSummary>
      <AccordionDetails>
        <Text component="p">
          <FormattedMessage id={answer} values={messageFormatValues} />
        </Text>
      </AccordionDetails>
    </Accordion>
  );
}

FaqItem.propTypes = {
  item: PropTypes.shape({
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired,
  }).isRequired,
};
export default FaqItem;
